var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"link",class:{ '-is-black': _vm.isBlack, icon: _vm.icon },attrs:{"href":_vm.link,"target":_vm.target}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),(_vm.icon)?_c('svg',{staticClass:"icon icon-arrow"},[_c('use',{attrs:{"xlink:href":"#icon-arrow"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }